<template>
    <div>
        <div style="margin-bottom: 10px;" v-if="url_upload_status">
            <div
                style="margin:0 0 10px 0;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;">
                <div style="font-weight: 600;font-size: 14px;">上传方式 (可交替使用)</div>
                <div style="display: flex;align-items: center;color: #444;">
                    <!-- <div style="display: flex;align-items: center;">
                        <div style="font-size: 12px;">不清空链接</div>
                        <el-switch v-model="clear_url_status" style="margin-left: 5px;" active-color="#67c23a">
                        </el-switch>
                    </div> -->
                    <!-- <div v-if="from == 'qc'"
                        style="background-color: #f1f1f1;font-size: 12px;padding: 5px 10px;border-radius: 4px;margin: 2px 3px;cursor: pointer;"
                        class="no-select"
                        :style="{ 'background-color': tietu_status ? '#67c23a' : '#f1f1f1', 'color': tietu_status ? '#fff' : '#444' }"
                        @click="tietu_status = !tietu_status">
                        贴图模式
                    </div> -->
                    <div style="background-color: #f1f1f1;font-size: 12px;padding: 5px 10px;border-radius: 4px;margin: 2px 3px;cursor: pointer;"
                        class="no-select"
                        :style="{ 'background-color': clear_url_status ? '#67c23a' : '#f1f1f1', 'color': clear_url_status ? '#fff' : '#444' }"
                        @click="clear_url_status = !clear_url_status">
                        不清空链接
                    </div>
                </div>
            </div>
            <div style="display: flex;background-color: #c0c4cc;border-radius: 18px;">
                <div class="no-select"
                    style="width: 50%;text-align: center;background-color: #484add;color: #fff;border-radius: 18px;font-weight: 600;font-size: 13px;"
                    :style="{
                        'background-color': upload_type == 1 ? '#484add' : '#c0c4cc',
                        'color': upload_type == 1 ? '#fff' : '#444'
                    }" @click="upload_type = 1">
                    链接上传
                </div>
                <div class="no-select"
                    style="width: 50%;text-align: center;background-color: #c0c4cc;color: #555;border-radius: 18px;font-weight: 600;font-size: 13px;"
                    :style="{
                        'background-color': upload_type == 2 ? '#484add' : '#c0c4cc',
                        'color': upload_type == 2 ? '#fff' : '#444'
                    }" @click="upload_type = 2">
                    {{ image_mode ? '图片上传' : '视频上传' }}
                </div>
            </div>
        </div>
        <!-- :on-remove="upload_remove" -->
        <div class="upload2" style="margin-bottom: 10px;" v-if="upload_type == 2">
            <div style="margin:0 0 10px 0;font-weight: 600;font-size: 14px;">{{ image_mode ? '图片上传' : '视频上传' }}</div>
            <el-upload drag action="#" ref="upload" :limit="limit_url" :before-upload="upload_fast"
                :file-list="url_list" :on-exceed="upload_xianzhi" :show-file-list="false"
                :accept="image_mode ? '.jpg,.png,.jpeg,.gif,.webp' : '.mp4,.mov' + (tietu_status ? ',image/*' : '')"
                :http-request="upload_duilie" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">{{ image_mode ? '只能上传图片文件，且单个不超过' + mb + 'MB' : '只能上传视频文件，且单个不超过' + mb + 'MB' }}，数量限制{{ limit_url }}个</div>
            </el-upload>
        </div>

        <div style="margin-bottom: 10px;" v-if="upload_type == 1">
            <div style="margin:0 0 10px 0;font-weight: 600;font-size: 14px;">链接上传</div>
            <el-input type="textarea" v-model="inputurl" placeholder="一行一个链接,回车换行"
                :autosize="{ minRows: 7, maxRows: 7 }">
            </el-input>
            <div style="display: flex;">
                <el-button type="primary"
                    style="width: 50%;margin-top: 10px;background-color: #464646;border-color: #464646;" size="small"
                    @click="getClipboardText()" icon="el-icon-document-copy">粘贴</el-button>
                <el-button type="primary"
                    style="width: 50%;margin-top: 10px;background-color: #67c23a;border-color: #67c23a;" size="small"
                    @click="url_jc" icon="el-icon-document-checked">确认链接</el-button>
            </div>
        </div>

        <div v-if="url_list.length > 0">
            <div
                style="margin: 12px 0;font-weight: 600;font-size: 14px;display: flex;justify-content: space-between;align-items: center;">
                {{ image_mode ? '已上传图片列表' : '已上传视频列表' }}
                <!-- <div style="font-weight: 500;font-size: 13px;color: #ce2b2b;cursor: pointer;" @click="url_list = []">
                    一键清空</div> -->
            </div>
            <div class="scroll-container"
                style="padding: 8px; background-color: #f5f5f5; border-radius: 8px; color: #666; font-size: 13px; max-height: 200px; overflow-y: auto;">
                <div v-for="(item, index) in url_list" :key="index"
                    style="display: flex; align-items: center; padding: 6px;">
                    <div
                        style="display: flex; align-items: center; justify-content: center; background-color: #484add; color: #fff; border-radius: 10px; font-size: 12px; width: 18px; height: 18px; margin-right: 6px;">
                        {{ index + 1 }}
                    </div>

                    <div
                        style="white-space: nowrap; display: block; overflow: hidden; text-overflow: ellipsis; flex: 1; font-size: 13px;">
                        {{ item.filename || item.url }}
                    </div>
                    <div style="margin-right: 5px;color: #1a9c34;" v-if="item.zt == 'uploading'">
                        <i class="el-icon-loading"></i>
                        {{ item.percentage }}
                    </div>
                    <div style="margin-right: 4px; font-size: 13px; color: #1a9c34;" v-if="item.zt == 'success'">
                        已上传
                    </div>
                    <div style="margin-right: 4px; font-size: 13px; color: #ff1031;" v-if="item.zt == 'error'">
                        {{ item.error_info ? item.error_info : '失败' }}
                    </div>
                    <div style="margin-left: 5px;" @click="del_url(index)">
                        <i class="el-icon-circle-close" style="font-size: 19px; cursor: pointer;"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CryptoJS from 'crypto-js';
export default {
    name: 'cosupload',
    components: {},
    props: {
        limit_url: {
            type: Number,
            default: 200
        },
        mb: {
            type: Number,
            default: 5
        },
        image_mode: {
            type: Boolean,
            default: false
        },
        from: {
            type: String,
            default: ''
        },
        upload_class: {
            type: String,
            default: 'video'
        },
        url_upload_status: {
            type: Boolean,
            default: false
        },
        uploadkey: {
            type: String,
            default: ''
        },

    },
    data() {
        return {
            upload_type: 2,
            inputurl: '',
            spnum: 0,
            video_num: 0,
            videoFileList: [],
            upload_info: false,
            uploadedChunks: {},
            url_list: [],
            uploadQueue: [], // 上传队列
            isUploading: false, // 标志位，指示是否有文件正在上传
            clear_url_status: false,
            tietu_status: false,
            use_cos: 1
        }
    },
    methods: {
        clear_url() {
            if (this.clear_url_status) return
            this.url_list = []
        },
        async getClipboardText() {
            try {
                const text = await navigator.clipboard.readText();
                console.log('剪切板内容:', text);
                this.inputurl = text
                // 在这里你可以将获取到的文本用于你的应用逻辑
            } catch (err) {
                console.error('无法读取剪切板内容:', err);
            }
        },
        get_urls(islist = 0) {
            var urls = islist == 0 ? '' : []
            for (var i = 0; i < this.url_list.length; i++) {
                if (this.url_list[i].zt == 'uploading') {
                    return { status: 100, msg: '请等待视频上传完成，或取消上传' }
                }
                if (this.url_list[i].zt == 'error') {
                    continue;
                }
                if (islist == 0) {
                    urls += this.url_list[i].url + '\n'
                } else {
                    urls.push(this.url_list[i])
                }
            }
            if (urls.length < 1) {
                return { status: 100, msg: '可制作视频为空，请先上传视频' }
            }
            return urls
        },
        del_url(index) {
            this.$confirm('确定删除' + this.url_list[index].url + ', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'newdialog',
                type: 'warning'
            }).then(() => {
                const fileWithController = this.url_list[index];
                if (fileWithController.zt == 'uploading') {
                    console.log(fileWithController)
                    if (fileWithController.abortController) {
                        fileWithController.abortController.abort();
                    }
                }
                const urlindex = this.uploadQueue.findIndex(f => f.uid === fileWithController.uid)
                if (urlindex !== -1) {
                    this.uploadQueue.splice(urlindex, 1);
                }
                this.url_list.splice(index, 1);
            });
        },
        url_jc() {

            const lines = this.inputurl.trim().split('\n').filter(line => line.trim() !== '');
            console.log(lines)
            for (let index = 0; index < lines.length; index++) {
                if (this.url_list.length >= this.limit_url) {
                    this.$toast.show("最多上传" + this.limit_url + "个链接", 2000);
                    return;
                }
                this.url_list.push({ url: lines[index], 'zt': 'success' });
            }
            this.$toast.show("识别有效链接" + lines.length + "个", 2000);
            this.inputurl = ''
            // this.urlnum = lines.length;
            // console.log(this.urlnum);
        },
        upload_fast(file) {
            if (this.image_mode) {
                const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
                if (!imageTypes.includes(file.type)) {
                    this.$message.error(`${file.name} 图片只能是 jpg、png、gif、webp 格式！`)
                    return false
                }
            } else {
                const validTypes = this.tietu_status
                    ? ['video/mp4', 'video/quicktime', 'image/*']
                    : ['video/mp4', 'video/quicktime'];

                let isValidType = false;
                isValidType = validTypes.some(type => {
                    if (type === 'image/*') {
                        return file.type.startsWith('image/');
                    } else {
                        return file.type === type;
                    }
                });

                if (!isValidType) {
                    const errorMsg = this.tietu_status
                        ? `${file.name} 文件类型不支持，只允许 mp4、mov 或图片格式！`
                        : `${file.name} 视频只能是 mp4 或 mov 格式！`;
                    this.$message.error(errorMsg);
                    return false;
                }
                // 图片数量限制检查（贴图模式）
                if (file.type.startsWith('image/')) {
                    const existingImagesCount = this.url_list.filter(item => item.filetype && item.filetype.startsWith('image/')).length;
                    if (existingImagesCount >= 1) {
                        this.$message.error('贴图模式只能上传一张图片，请删除后再上传');
                        return false;
                    }
                }
            }
            // 文件大小校验
            const maxSize = this.mb * 1024 * 1024;
            if (file.size > maxSize) {
                this.$message.error(`${file.name} 文件大小不能超过 ${this.mb}MB！`);
                return false;
            }

            return true;
        },
        upload_xianzhi(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.limit_url} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        upload_change(file, fileList) {

            if (!this.videoFileList.some(f => f.uid === file.uid)) {
                // file.start = 'uploading'
                this.videoFileList.push(file);
            }
            this.video_num = fileList.length;
        },
        async upload_duilie(options) {
            const { file } = options;
            file.fileHash = await this.generateFileHash(file);
            // 预先获取音视频时长（仅针对音视频文件）
            if (!file.durationSeconds && (file.type.startsWith('video/') || file.type.startsWith('audio/'))) {
                file.durationSeconds = await this.getMediaDuration(file);
            }
            if (!this.url_list.some(f => f.uid === file.uid)) {
                this.url_list.push({
                    uid: file.uid, url: '', 'percentage': '准备开始上传', zt: 'uploading', filename: file.name, filetype: file.type,
                    duration: file.durationSeconds || 0
                });
            }
            try {
                const timestamp = Math.floor(Date.now() / 1000);
                if (this.upload_info && timestamp - this.upload_info.time > this.upload_info.max_time) {
                    this.upload_info = false;
                }
                if (!this.upload_info) {
                    this.upload_info = await this.getUploadUrl();
                }
                if (this.upload_info) {
                    // this.upload_info.upload_url = 'https://localhost:9991/upload_chunk.php';
                    this.uploadQueue.push(file); // 将文件添加到上传队列
                    this.processUploadQueue(); // 处理上传队列
                } else {
                    this.isUploading = false;
                    this.update_file(file, 'error', '获取上传地址失败')
                }
            } catch (error) {
                this.$message.error(`获取上传地址失败: ${error.message}`);
                this.isUploading = false;
                this.update_file(file, 'error', '获取上传地址失败')
            }
        },
        processUploadQueue() {
            if (this.isUploading || this.uploadQueue.length === 0) {
                return; // 如果正在上传或队列为空，直接返回
            }

            this.isUploading = true; // 设置标志位为正在上传
            const file = this.uploadQueue.shift(); // 从队列中取出第一个文件
            if (this.use_cos) {
                this.cos_uploadFile(file, this.upload_info);
            } else {
                this.upload_file(file, this.upload_info);
            }
        },
        async getUploadUrl() {
            try {
                const response = await this.$ajax.post('/qhy/app/upload_dz', {
                    num: 1,
                    xgcs: 1,
                }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                console.log(response.data);
                if (response.data.status == 200) {
                    return response.data.data;
                } else {
                    this.$message.error(response.data.msg);
                    return false;
                }
            } catch (error) {
                return false;
            }
        },
        generateFileHash(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                const blob = file.slice(0, 1024 * 1024); // 读取前1MB
                reader.onload = (event) => {
                    const fileContent = event.target.result;
                    const originalHash = CryptoJS.SHA256(fileContent + file.name + file.size + file.lastModified).toString();
                    const finalHash = originalHash.length >= 15
                        ? originalHash.slice(-15) // 截取最后15位
                        : originalHash; // 不足15位则保留原字符串
                    resolve(finalHash);
                };
                reader.onerror = (error) => {
                    reject(error);
                };
                reader.readAsArrayBuffer(blob);
            });
        },
        async upload_file(file, upload_data) {
            console.log('开始上传信息', upload_data, file);
            const urlindex = this.url_list.findIndex(f => f.uid === file.uid)
            const chunkSize = 1024 * 1024; // 1MB
            const totalChunks = Math.ceil(file.size / chunkSize);
            let currentChunk = 0;

            const abortController = new AbortController();
            // file.abortController = abortController;
            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].abortController = abortController;
            console.log('分片数量', totalChunks);
            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].percentage = '上传中1%';
            // 获取已上传的分片信息
            try {
                const response = await this.$ajax_upload.post(upload_data.upload_url, {
                    fileHash: file.fileHash,
                    filename: file.name,
                    totalChunks: totalChunks,
                    action: 'get_uploaded_chunks',
                    token: upload_data.token,
                }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                console.log(response.data);
                if (response.data.code === 200) {
                    if (response.data.dz) {
                        this.update_file(file, 'success', response.data.dz)
                        return
                    }
                    this.uploadedChunks[file.fileHash] = response.data.uploadedChunks || [];
                    if (this.uploadedChunks[file.fileHash].length > 0) {
                        currentChunk = Math.max(...this.uploadedChunks[file.fileHash]) + 1;
                    }
                    console.log('已上传分片信息', this.uploadedChunks[file.fileHash]);
                } else {
                    throw new Error(response.data.msg);
                }
            } catch (error) {
                this.$message.error(`获取已上传分片信息失败: ${error.message}`);
                this.update_file(file, 'error', error.message)
                return;
            }

            const uploadChunk = () => {
                const start = currentChunk * chunkSize;
                const end = Math.min(file.size, start + chunkSize);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append('file', chunk);
                formData.append('filename', file.name);
                formData.append('chunk', currentChunk);
                formData.append('totalChunks', totalChunks);
                formData.append('fileHash', file.fileHash); // 添加文件哈希值
                formData.append('token', upload_data.token);
                console.log('开始上传', currentChunk)
                this.$ajax_upload.post(upload_data.upload_url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    signal: abortController.signal
                }).then(response => {
                    console.log(response.data);
                    if (response.data.code === 201) {
                        console.log(this.url_list.findIndex(f => f.uid === file.uid))
                        if (this.url_list[this.url_list.findIndex(f => f.uid === file.uid)]) {
                            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].percentage = '上传中' + ((currentChunk + 1) * (100 / totalChunks)).toFixed(0) + '%';
                        } else {
                            throw new Error('上传已取消');
                        }
                        this.uploadedChunks[file.fileHash].push(currentChunk);
                    }
                    currentChunk++;
                    if (currentChunk >= totalChunks) {
                        if (response.data.code === 200) {
                            this.update_file(file, 'success', response.data.dz)
                        } else {
                            this.update_file(file, 'error', response.data.msg)
                        }
                        return;
                    } else {
                        uploadChunk();
                    }

                }).catch(error => {
                    console.log(error)
                    if (error.message == 'canceled') {
                        this.$message.error(`${file.name} 已取消上传`);
                    } else {
                        this.$message.error(`${file.name} ${error.message}`);
                    }
                    this.update_file(file, 'error', error.message)
                });
            };
            uploadChunk();
        },
        update_file(file, type, dz, src_data = null) {
            const index = this.url_list.findIndex(f => f.uid === file.uid);
            if (index !== -1) {
                if (type === 'success') {
                    this.$message.success(`${file.name} 上传成功!`);
                    this.url_list[index].url = dz;
                    this.url_list[index].zt = type;
                    if (file.durationSeconds) {
                        this.url_list[index].duration = file.durationSeconds;
                    }
                    // 发出上传成功事件，如果有 src_data 则传递
                    this.$emit('upload-success', {
                        file: file,
                        url: dz,
                        filetype: file.type,
                        duration: file.durationSeconds || 0,
                        src_data: src_data
                    });
                } else if (type === 'error') {
                    this.url_list[index].zt = type;
                    this.url_list[index].error_info = dz;
                }
                delete this.url_list[index].abortController;
            }
            this.isUploading = false;
            this.processUploadQueue();
        },
        async cos_uploadFile(file) {
            console.log(file)
            var that = this

            return new Promise((resolve, reject) => {
                // 保存上传信息中的 src_data
                var uploadInfoData = null;

                // 获取上传路径、上传凭证
                var getUploadInfo = function (extName, size, callback) {
                    that.$ajax.post('/qhy/app/upload_cos_src', {
                        ext: extName,
                        size: size,
                        filename: file.name,
                        upload_class: that.upload_class,
                        uploadkey: that.uploadkey,
                        duration: file.durationSeconds || 0
                    }, {
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    }).then(res => {
                        console.log(res)
                        if (res.data.status == 100) {
                            that.$message.error(res.data.msg || '上传失败,联系客服')
                            that.update_file(file, 'error', res.data.msg || '上传失败,联系客服')
                            return
                        }
                        // 保存上传信息，包括 src_data
                        uploadInfoData = res.data.data;
                        callback && callback(null, res.data.data);
                    }).catch(err => {
                        console.error('获取上传信息失败:', err)
                        that.$message.error('获取上传信息失败')
                        that.update_file(file, 'error', '获取上传信息失败')
                        callback && callback(err, null);
                    })
                };

                // 发起上传请求
                var uploadFile = function (opt, callback) {
                    // 设置初始进度
                    const fileIndex = that.url_list.findIndex(f => f.uid === file.uid);
                    if (fileIndex !== -1 && that.url_list[fileIndex]) {
                        that.url_list[fileIndex].percentage = '准备开始上传';
                        that.url_list[fileIndex].zt = 'uploading';
                    }

                    var formData = new FormData();
                    formData.append('key', opt.cosKey);
                    formData.append('policy', opt.policy);
                    formData.append('success_action_status', '200');
                    formData.append('q-sign-algorithm', opt.qSignAlgorithm);
                    formData.append('q-ak', opt.qAk);
                    formData.append('q-key-time', opt.qKeyTime);
                    formData.append('q-signature', opt.qSignature);

                    // 如果服务端用了临时密钥计算，需要传 x-cos-security-token
                    if (opt.securityToken) {
                        formData.append('x-cos-security-token', opt.securityToken);
                    }
                    formData.append('file', file);

                    // 使用 axios 上传文件
                    that.$ajax_upload.post(opt.cosHost, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function (progressEvent) {
                            // console.log(progressEvent)
                            if (progressEvent.loaded && progressEvent.total) {
                                const percentCompleted = Math.round(progressEvent.progress * 100);
                                const loaded = (progressEvent.loaded / 1024 / 1024).toFixed(2);
                                const total = (progressEvent.total / 1024 / 1024).toFixed(2);
                                const speed = progressEvent.rate ? (progressEvent.rate / 1024 / 1024).toFixed(2) : '0';
                                console.log('上传进度' + percentCompleted);
                                const fileIndex = that.url_list.findIndex(f => f.uid === file.uid);
                                if (fileIndex !== -1 && that.url_list[fileIndex]) {
                                    that.url_list[fileIndex].percentage = `上传中${percentCompleted}% (${loaded}MB/${total}MB ${speed}MB/s)`;
                                    // 强制更新视图
                                    that.$forceUpdate();
                                }
                            }
                        }
                    }).then(res => {
                        console.log(res)
                        const statusCode = res.status || res.statusCode || 200
                        if (![200, 204].includes(statusCode)) {
                            that.update_file(file, 'error', '上传失败,联系客服', null)
                            callback && callback(new Error('上传失败'));
                            return
                        }
                        // 传递 src_data 给 update_file
                        that.update_file(file, 'success', opt.okdz, uploadInfoData ? uploadInfoData.src_data : null)
                        callback && callback(null, opt.okdz);
                    }).catch(err => {
                        console.error('上传失败:', err)
                        that.update_file(file, 'error', '上传失败,联系客服', null)
                        callback && callback(err);
                    });
                };

                // 获取后缀
                var lastIndex = file.name.lastIndexOf('.');
                var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1).toLowerCase() : '';

                if (!extName) {
                    if (file.type && file.type.startsWith('image/')) {
                        extName = 'jpg'
                    }
                    if (file.type && file.type.startsWith('video/')) {
                        extName = 'mp4'
                    }
                }

                getUploadInfo(extName, file.size, function (err, info) {
                    if (err) {
                        reject(err);
                        return;
                    }
                    // 上传文件
                    uploadFile(info, function (err, fileUrl) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(fileUrl);
                        }
                    });
                });
            })
        },
        getMediaDuration(file) {
            return new Promise(resolve => {
                try {
                    const objectUrl = URL.createObjectURL(file);
                    const isAudio = file.type && file.type.startsWith('audio/');
                    const media = document.createElement(isAudio ? 'audio' : 'video');
                    media.preload = 'metadata';
                    const cleanup = () => {
                        media.removeAttribute('src');
                        media.load();
                        URL.revokeObjectURL(objectUrl);
                    };
                    media.onloadedmetadata = () => {
                        const duration = Number.isFinite(media.duration) ? Math.round(media.duration) : 0;
                        console.log('媒体时长', duration)
                        cleanup();
                        resolve(duration);
                    };
                    media.onerror = () => {
                        cleanup();
                        resolve(0);
                    };
                    media.src = objectUrl;
                } catch (error) {
                    resolve(0);
                }
            });
        }
    }
}
</script>

<style scoped>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}

.scroll-container::-webkit-scrollbar {
    width: 5px;
    /* 滚动条宽度 */
}

.scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道背景色 */
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条滑块背景色 */
    border-radius: 4px;
    /* 滚动条滑块圆角 */
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滚动条滑块悬停背景色 */
}
</style>


// WEBPACK FOOTER //
// src/components/common/cosupload.vue